const $ = require('jquery');
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import render from "../../utilities/render";
import EditChecker from '../../components/EditChecker/EditChecker';
import run from '../../utilities/run';
import {validateOnAllSelectChanges} from "../../utilities/select2able";
import {isPresent} from "../../utilities/general";
require("../stubs/orderWizard/orderWizardStub.less");
import {calcShippingMethod, shippingMethodTypeValidation} from "./preparationTab.js";
import DestinationTab from './destinationTab.js';
import ProductsTab from './ProductsTab.js';
import ReviewTab from './ReviewTab.js';
import addressValidationFactory from '../common/AddressValidation.js';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import _ from 'underscore';
import  PreparationTab from "./preparationTab.js";
const editSubmissionFailModalBodyHtml = require('./html/editSubmissionFailModalBody.html');
const modalHtml = require("../../sharedHtml/modal.html");

// Live form from jsp
run("#create-order-form", ()=>{
  const el = $("#create-order-form");
  attachWizard(el);
  setupEditChecker();
});

function showHideDropFlag(cotCode) {
  const consolidatedOrderTypeList = $("#destination-tab-order-type-select").data("consolidated-order-type-list");
  const groupedOrderTypeList = _.groupBy(consolidatedOrderTypeList, 'ortTypeCode')
  const orderTypeList = groupedOrderTypeList[cotCode] || []
  let dropShipValue;
  const found = _.findIndex(orderTypeList, (value) => {
    return ! _.isNull(value.ortDropShip)
  })
  if (found >= 0) {
    const dropShipFlagVal = $("#dropShipFlag").is(":checked");
    if (dropShipFlagVal) {
      dropShipValue = true;
    } else {
      dropShipValue = false;
    }
  }else{
    dropShipValue=null;
  }
  return dropShipValue;
}

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-order-form");
  EditChecker.bindChangeListener("span.select2");
  EditChecker.bindCancelButton("#create-order-cancel-btn");
}

function attachWizard(el){
  const hiddenAddressInput = $("#order-validated-address");
  const viewOrderDetailURL = el.data("view-order-detail-url");
  const submitOrderURL  = el.data("submit-order-url");
  var countryVal = $('#destination-tab-country  :selected').val();
  const orderDetailsForEdit = el.data("edit-order-details");
  if(!$.isEmptyObject(orderDetailsForEdit)){
      const order = orderDetailsForEdit.orderDetails;
      const error = orderDetailsForEdit.error;
  }
  const isChannelOrder = el.data("is-channel-order");
  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
    // Place all your validation rules here!!!
    // rules: {

    // }
  });

  validator.settings.ignore = ":disabled,:hidden";

  const editSubmissionFailModal = $(render(
    modalHtml,{
      title: 'Edit Submission Failed',
      leftAlignTitle: true,
      topCloseBtn: true,
      modalDialogClass: 'q-modal-dialog-500',
      body: editSubmissionFailModalBodyHtml,
      footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
        <a href="#" class="base-btn purple-btn modal-auto-hide redirect-order-detail">Order Details</a>
      `
  }));


	const submitModalFlow = new SubmitModalFlow({
		confirmModalTitle: 'Submit Order',
		// confirmModalSubtitle: "Optional Subtitle",
		confirmModalBody: '<div class="q-pad-all-xl">Once submitted, this order will be processed and set to held or released. Once this order has been released, it cannot be canceled.</div>',
		onConfirmClick: function(){
			// Show Loading Modal
			  submitModalFlow.showLoadingModal();

			// call ajax funtion here.
			submitOrder({url: submitOrderURL, success: submitOrderSuccess, error: submitOrderError});
		  }
	});

  submitModalFlow.init();

  function submitOrder({ url, success, error }) {
    let dropShipValue = showHideDropFlag($("#destination-tab-order-type-select").val());
    let declaredValue = $("#declared-value-checkbox").is(":checked");
    let satDeliveryValue = $("#saturday-delivery-checkbox").val();
    $.ajax({
      data: $("#create-order-form").serialize()+"&dropShipFlagValue="+dropShipValue+"&declaredValue="+declaredValue+"&satDeliveryValue="+satDeliveryValue,
      url: url,
      type: 'POST',
      success: success,
      error: error
    });
  }

  function submitOrderSuccess(orderId){
    if(orderId.indexOf("edit-unavailable") > -1){
      submitModalFlow.hideAllModals();
      showEditunavailableModal();
    }else if(orderId){
	  EditChecker.setPageClean();
      submitModalFlow.showSuccessModal();
	  setTimeout(function() {
		 const orderDetailUrlFullURL = `${viewOrderDetailURL}&orderId=${orderId}`;
		 window.location.href = orderDetailUrlFullURL;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }
  }


  function submitOrderError(){
	  submitModalFlow.showFailureModal();
  }


   $(".create-button").on('click', function() {
	 submitModalFlow.showConfirmModal();
   });

  function showEditunavailableModal(){
    el.append(editSubmissionFailModal);
    editSubmissionFailModal.modal('show');
   }


   el.on("click", '.redirect-order-detail', redirectToDetailsPage);

   function redirectToDetailsPage(){
    EditChecker.setPageClean();
    editSubmissionFailModal.modal('hide');
    const orderDetailUrlFullURL = `${viewOrderDetailURL}&orderId=${orderDetailsForEdit.orderDetails.ordOrderId}`;
    window.location.href = orderDetailUrlFullURL;
   }

   let btnClickVar=false;
   let fedexShipping=false;
   let serviceLevels=false;
   const fedexShippingMethodBtnValueCheck = el.find("#fedex-shipping-method-btn-value-check");
   const serviceLevelsBtnValueCheck = el.find("#service-levels-btn-value-check");
   const fedexShippingMethodBtn = el.find(".fedex-shipping-method-btn");
   const serviceLevelsBtn = el.find(".service-levels-btn");
   const serviceLevelsMessage = el.find(".estimated-delivery-date-message");

   el.on('click','.fedex-shipping-method-btn, .service-levels-btn', function(e){
    btnClickVar=true;
   });

   el.on('click','.fedex-shipping-method-btn', function(e){
    fedexShippingMethodBtn.addClass("active");
    serviceLevelsBtn.removeClass("active");
    fedexShipping=true;
    serviceLevels=false;
    fedexShippingMethodBtnValueCheck.val(true);
    serviceLevelsBtnValueCheck.val(false);
    serviceLevelsMessage.hide();
   });

   el.on('click','.service-levels-btn', function(e){
    fedexShippingMethodBtn.removeClass("active");
    serviceLevelsBtn.addClass("active");
    serviceLevels=true;
    fedexShipping=false;
    serviceLevelsBtnValueCheck.val(true);
    fedexShippingMethodBtnValueCheck.val(false);
    serviceLevelsMessage.show();
   });

   $('#shipping-tab-shipping-type-select').on('change', function(e){
      if($('#shipping-tab-shipping-type-select').val()=="LTL"){
            btnClickVar=true;
            fedexShipping=false;
            serviceLevels=false;
        }

        if($('#shipping-tab-shipping-type-select').val()=="PCL"){
           if(fedexShipping || serviceLevels){
             btnClickVar=true;
           }else{
            btnClickVar=false;
           }

          var countryVal = $('#destination-tab-country  :selected').val();
          if(countryVal != "1"){
            btnClickVar=true;
          }

        }
    });


  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 844,
    mobileWidthNavStep: 502,

    customRules: {
      "#products-empty-table-validator": {
        errorMessageSelector: ".products-tab-products-table-error-message",
        isValid: function(){
          return productsTab.isValid();
        }
      },
      "#destination-tab-customerEmail": {
        errorMessageSelector: "#create-order-invalid-email",
        isValid: ({input, done})=>{
          const curVal = input.val();
          if(isPresent(curVal)) {
            let atpos = curVal.indexOf("@");
            let dotpos = curVal.lastIndexOf(".");
            if (atpos<1 || dotpos<atpos+2 || dotpos+2>=curVal.length) {
                done(false, {displayErrors: true});
            } else {
              done(true, {displayErrors: true});
            }
          } else {
            done(true, {displayErrors: true});
          }
          return done;
        }
      },
      "#business-exception-validator" : {
        errorMessageSelector: ".products-tab-business-exception-error-message",
        isValid: function(){;
          return !productsTab.checkIfBusinessExceptionsExist();
        }
      }, 
      "#schedule-release-time" : {
        errorMessageSelector: ".time-picker-error",
        isValid: function(){
          return !preparationTab.checkIfDateTimeInPast();
        }
      }
    },

    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
     // Any time we go traverse backwards, just let us
      if(currentForm.filter(".shipping-tab").length){
        if(targetForm.filter(".products-tab").length){
          direction = "BACKWARDS";
        }
      }

      if(direction === "BACKWARDS"){
        return true;
      }

  	  if(currentForm.filter(".destination-tab").length) {
	    	areInputsValid(true, (validResult)=>{
          handleInputsFinishedValidatingForDestinationTab(validResult, done);
        });
  	  } else if(currentForm.filter('.shipping-tab').length) {
          let isShippingOrServiceLevelSelected = false;
          let countryVal = $('#destination-tab-country  :selected').val();
          let shippingTypeSelected =  $('#shipping-tab-shipping-type-select').val();
          let fedexShippingSelected = ((!fedexShippingMethodBtn.is("hidden")) && fedexShippingMethodBtn.hasClass("active"));
          let serviceLevelSelected = ((!serviceLevelsBtn.is("hidden")) && serviceLevelsBtn.hasClass("active"));
          if(shippingTypeSelected == "LTL") {
            btnClickVar = true; 
          } else {
            if(fedexShippingSelected || serviceLevelSelected) {
              isShippingOrServiceLevelSelected = true;
            } 
            if(isShippingOrServiceLevelSelected) {
              btnClickVar = true;
            } else {
              //Check if is a channel custom shipping method 
             //Toggle turned to YES,set to TRUE else set to FALSE, For non US set to True  
              let retainChannelShipmentCheck = el.find("#channelShippingMethodCheck");
              if(retainChannelShipmentCheck.length > 0) { 
                if(isChannelOrder && retainChannelShipmentCheck.is(":checked") && countryVal ==1) {
                  btnClickVar = true;
                } else if(isChannelOrder && countryVal !=1) {
                  btnClickVar = true;
                } else {
                  btnClickVar = false;
                }
              } else {
                if($('#shipping-tab-shipping-type-select').val()=="PCL"){
                 let countryVal = $('#destination-tab-country  :selected').val();
                 if(countryVal != "1"){
                   btnClickVar=true;
                 }
               }
              }
            } 
          }
    
          areInputsValid(btnClickVar, done);
      } else {
  		  areInputsValid(true, done);
  	  }

  	  function areInputsValid(shouldContinue, cb) {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, {displayErrors: true});
        if(notValid || !shouldContinue){
          if(notValid){
            quickWizard.goToFirstIncompleteForm();
          }
          cb(false);
        } else {
          cb(true);
        }
  	  }

      function handleInputsFinishedValidatingForDestinationTab(validResult, cb) {
	    if(validResult){
          addressValidation.determineAddressValidity((useAddress) => {
            if(useAddress){
              const validatedAddress = addressValidation.getAddressResponse();
              hiddenAddressInput.val(JSON.stringify(validatedAddress));
              cb(true);
            }else{
              cb(false);
            }
          });
        } else {
          cb(validResult);
        }
      }

	    return done;
    },

    didNavigateToForm: function({currentForm, currentDirection}){
      if(currentForm.filter('.review-tab').length){
        preparationTab.getScheduleReleaseTimeAndDate();
        reviewTab.didNavigateToForm();
      } else if(currentForm.filter('.shipping-tab').length) {   
        if(currentDirection == "FORWARDS") {
          preparationTab.handleDestTabOrderTypeLoad();
          calcShippingMethod();
        }  
     } else if(currentForm.filter('.products-tab').length){
        productsTab.didNavigateToForm();
    		let countryVal = $('#destination-tab-country  :selected').val();
    		  if(countryVal == "-1" || countryVal == "1") {
    			  $("#product-tab-internation-msg-id").hide();
    			  //productsTab.setProductLookupAndModal(productsTab.productItems.regularItems , productsTab.productNameArr.regularItems);
    			  $("#products-list").show();
    			  $("#international-products-list").hide();
    			  $(".qw-products-intl-order").hide();
    		  } else {
      			$("#product-tab-internation-msg-id").show();
      			//productsTab.setProductLookupAndModal(productsTab.productItems.internationalItems, productsTab.productNameArr.internationalItems);
      			$("#products-list").hide();
      			$("#international-products-list").show();
      			$(".qw-products-intl-order").show();
    		  }
      }
    }
  });

  quickWizard.init();

  const destinationTab = new DestinationTab(quickWizard);
  destinationTab.init();

  const productsTab = new ProductsTab(quickWizard);
  productsTab.init();

  const preparationTab =  new PreparationTab(quickWizard);
  preparationTab.init();

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();

  const addressValidationModalEl = $("#add-validation-model");
  let isAddressValidationRequired = destinationTab.checkForAddressValidationBusinessException(orderDetailsForEdit);
  const addressValidation = addressValidationFactory(addressValidationModalEl, el, {
    isAlreadyValid: !isAddressValidationRequired
  });
  validateOnAllSelectChanges();
}



// WEBPACK FOOTER //
// ./src/pages/order/createOrderWizard.js